"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAlertactionType = void 0;
var IAlertactionType;
(function (IAlertactionType) {
    IAlertactionType["DELIVER_THE_ALERT_TO_AN_EMAIL_ADDRESS_EMAIL"] = "email";
    IAlertactionType["DELIVER_THE_ALERT_THROUGH_A_WEB_SITE_NOTIFICATION_WEB"] = "web";
    IAlertactionType["DELIVER_THE_ALERT_THROUGH_A_MOBILE_APPLICATION_NOTIFICATION_APP"] = "app";
    IAlertactionType["DELIVER_THE_ALERT_THROUGH_AN_SMS_MESSAGE_TO_A_MOBILE_DEVICE_SMS"] = "sms";
})(IAlertactionType = exports.IAlertactionType || (exports.IAlertactionType = {}));
